// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"296":"privacy","443":"about","631":"contact","720":"faq"}[chunkId] + "." + {"296":"b335f8fb","443":"ebfd6599","631":"047dacbb","720":"fa9e7d18"}[chunkId] + ".js";
};